import styled from '@emotion/styled/macro';

export const Timeline = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: 12px;
  color: #6b778c;
`;

export const DayPoint = styled.div`
  display: flex;
  width: 100%;
  padding-top: 4px;
`;

export const WeekPoint = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  padding-top: 4px;
  padding-right: 6px;
`;

export const SecondsByDate = styled.div`
  margin-left: 4px;
`;

export const SecondsByWeek = styled.div`
  margin-left: 4px;
`;
